export const USER_ORDER_REQUEST = "USER_ORDER_REQUEST"
export const USER_ORDER_SUCCESS = "USER_ORDER_SUCCESS"
export const USER_ORDER_FAIL = "USER_ORDER_FAIL"
export const USER_ORDER_ERRORS = "USER_ORDER_ERRORS"

export const USER_ORDERSTAT_REQUEST = "USER_ORDERSTAT_REQUEST"
export const USER_ORDERSTAT_SUCCESS = "USER_ORDERSTAT_SUCCESS"
export const USER_ORDERSTAT_FAIL = "USER_ORDERSTAT_FAIL"

export const ALL_ORDERS_REQUEST = "ALL_ORDERS_REQUEST"
export const ALL_ORDERS_SUCCESS = "ALL_ORDERS_SUCCESS"
export const ALL_ORDERS_FAIL = "ALL_ORDERS_FAIL"

export const USERS_ALLORDERS_REQUEST = "USERS_ALLORDERS_REQUEST"
export const USERS_ALLORDERS_SUCCESS = "USERS_ALLORDERS_SUCCESS"
export const USERS_ALLORDERS_FAIL = "USERS_ALLORDERS_FAIL"